/**
 * Plurals do catálogo teamTasks usam chave / chave_plural.
 * O i18next v4 (padrão) resolve _one/_other e ignora _plural — por isso
 * não dá para depender só de t(key, { count }).
 */
export function tPlural(t, key, count, extra = {}) {
  const n = Number(count);
  const safe = Number.isFinite(n) ? n : 0;
  return t(safe === 1 ? key : `${key}_plural`, { count: safe, ...extra });
}
